export default "__VITE_ASSET__CnAI6qot__"